import { useMemo } from 'react';
import { SRCImage } from 'react-datocms';
import { CdaStructuredTextRecord } from 'react-datocms/structured-text';
import { Carousel } from '@carbonify/ui';
import { ResponsiveImage } from 'services/graphql';

interface CardBlockRecord extends CdaStructuredTextRecord {
  carouselImages: ResponsiveImage[];
  infiniteLoop?: boolean | null;
}

export default function CarouselBlock({ carouselImages, infiniteLoop = true }: CardBlockRecord) {
  const items = useMemo(
    () =>
      carouselImages.map(({ responsiveImage }, index) => (
        <SRCImage
          key={index}
          usePlaceholder={false}
          data={responsiveImage}
          imgClassName="!h-full object-contain mx-auto"
          pictureClassName="w-full h-full"
        />
      )),
    [carouselImages],
  );
  return (
    <Carousel
      items={items}
      autoScroll
      infiniteLoop={infiniteLoop !== false}
    />
  );
}
